import React, { useCallback, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ViewPane } from '@framework-controls/core';
import { IView } from 'Framework';
// import { JSXSwitch, JSXCase } from '@framework-controls/jsxconditions';
import * as css from './Main.module.scss';
import { ComponentMapIds } from 'src/components/map';
import { ViewMode } from 'src/enums';
import { SpecData, NewVehicle, Customer, UpdateApptVehInp, VehicleRecs, UpdateApptOpsInp, UpdateApptDateInp, ServiceDocsData, UpdateApptCustInp, ApptCust, ascMenuInteractionInput, ascElementConfigurationInput, ascCtaInteractionInput } from 'src/models';
import Menu from 'src/components/Menu/containers/Menu';
import MenuCustAppt from 'src/components/MenuCustAcct/containers/MenuCustAcct';
import MenuServiceDocs from '../MenuServiceDocs/containers/MenuServiceDocs';
import RenderComponent from 'src/components/RenderComponent/RenderComponent';
import Accessibility from '../Accessibility/containers/Accessibility';
import { setLocale, strings } from 'src/localization';
import { getBackgroundPath } from 'src/helpers/OEMHelper/OEMHelper';
import classNames from 'classnames';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { useHistory } from 'react-router';
import { IServicesState, IAppointmentState, ISpecsState } from 'src/store/states';
import PreviewOverlay from '../PreviewOverlay/PreviewOverlay';
import { ascMenuInteraction, ascElementConfiguration, ascCtaInteraction, getElementColor } from 'src/helpers/EventHelper/EventHelper';


export interface IProps {
    rtsToken: string;
    mainPaneViewOrder: IView[];
    viewMode: ViewMode;
    specData: SpecData | undefined;
    selectedVehicle: string;
    newVehOptions?: NewVehicle;
    custVehicles?: VehicleRecs;
    custNameId: string;
    theme: string;
    vehicles: VehicleRecs;
    additionalServices: IServicesState;
    appState: IAppointmentState;
    specState: ISpecsState;
    skipServicesFlag?: boolean;
    multipleCustomers?: boolean;
    serviceDocsSpecs?: ServiceDocsData;
    profileNum: string;
    serviceDocsFlag: string;
    viewServiceHistFlag: string;
    apptCust: ApptCust;
    locale: string;
    login: boolean;
    profileOpen: boolean;
    countryCode: string;
    langOption: string;
    pushToMainPanes: (inputView: IView) => void;
    popFromMainPane: (id: string) => void;
    setViewMode: (viewMode: ViewMode) => void;
    clearNewVehicle: () => void;
    onCustUpdate: (cust: Customer) => void;
    clearApptCust: () => void;
    selectVehicle: (id: string) => void;
    clearAdditionalServices: () => void;
    clearMaintContractData: () => void;
    onUpdateApptVehicle: (inp: UpdateApptVehInp) => void;
    clearVehicles: () => void;
    getVehicles: () => void;
    addLogEntry: (action: string, screen: string, details: string) => void;
    clearCheckedWebOps: () => void;
    clearCheckedAdditionalServices: () => void;
    updateApptOps: (inp: UpdateApptOpsInp[]) => void;
    updateApptDate: (inp: UpdateApptDateInp) => void;
    updateApptCust: (inp: UpdateApptCustInp) => void;
    setVerifyingIdentity: (verifyingIdentity: boolean) => void;
    setSendSecurityCode: (inp: boolean) => void;
    waitForLogOff: () => void;
    logCustOff: () => void;
    clearAddVinError: () => void;
    clearGMInfo: () => void;
    toggleLangLits: (language: string) => void;
    toggleLocale: (locale: string) => void;
    toggleOpsLangLits: (language: string) => void;
    toggleROLangLits: (language: string) => void;
    toggleApptLangLits: (language: string) => void;
}

const Main = (props: IProps & RouteComponentProps) => {
    const [backWarning, setBackWarning] = useState(false);
    const [langLit, setLangLit] = useState('Français');
    const mainViewPanes = props.mainPaneViewOrder.map((view): IView => ({ ...view }));

    const history = useHistory();

    const isPreview = new URLSearchParams(window.location.search).get('mode') === 'p' ? true : false;

    let langBtnCss = css.NolangToggle;
    let langLandBtnCss = css.NolangToggleLand;
    if (props.specData?.langOption === 'Y') {
        langBtnCss = css.langToggle;
        langLandBtnCss = css.langToggleLand;
    }
    if (props.theme === 'porsche') {
        langBtnCss += ' ' + css.langTogglePorsche;
        langLandBtnCss += ' ' + css.langTogglePorsche;
    }
    if (props.theme === 'lexus') {
        langBtnCss += ' ' + css.langToggleLexus;
        langLandBtnCss += ' ' + css.langToggleLexus;
    }

    useEffect(() => {
        if (props.locale === 'en-US' || props.locale === 'en-CA') {
            setLangLit('Français');
        } else {
            setLangLit('English');
        }
    }, [props.locale]);

    const changeLanguage = useCallback((e: any, text: string) => {
        let language = props.locale;
        if (props.locale === 'en-US' || props.locale === 'en-CA') {
            language = 'fr-CA';
        } else {
            if (props.countryCode === 'CA') {
                language = 'en-CA';
            } else {
                language = 'en-US';
            }
        }
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: text,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'accessibility_tool',
            elementSubType: 'selection_link',
            eventAction: 'click',
            eventActionResult: 'language toggle',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: text,
            elementType: 'accessibility_tool',
            elementColor: elementColor,
            eventAction: 'click',
            eventActionResult: 'language toggle',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, '');
        setLocale(language);
        props.toggleLocale(language);
        props.toggleLangLits(language);
        props.toggleOpsLangLits(language);
        props.toggleROLangLits(language);
        props.toggleApptLangLits(language);
    }, [props.countryCode,
        props.locale,
        props.toggleLocale,
        props.toggleLangLits,
        props.toggleOpsLangLits,
        props.toggleROLangLits,
        props.toggleApptLangLits,
        props.vehicles,
        props.selectedVehicle]);


    // on refresh change the url back to /

    // If the ViewMode is LandingPage then make sure we go back to the LandingPage
    // useEffect(() => {
    //     if (props.viewMode === ViewMode.LandingPage) {
    //         // props.history.push('/');
    //     }
    // }, [props?.history, props?.viewMode, mainViewPanes, props.pushToMainPanes]);
    if (mainViewPanes.length === 0) {
        mainViewPanes.unshift({
            viewId: ComponentMapIds.LandingPage,
            component: ComponentMapIds.LandingPage,
        });
        props.pushToMainPanes({
            viewId: ComponentMapIds.LandingPage,
            component: ComponentMapIds.LandingPage,
        });
    }

    //     switch (props.history.location.pathname) {
    //         case '/main':
    //             props.setViewMode(ViewMode.Appt);
    //             mainViewPanes.unshift({
    //                 viewId: ComponentMapIds.ApptCust,
    //                 component: ComponentMapIds.ApptCust,
    //             });
    //             props.pushToMainPanes({
    //                 viewId: ComponentMapIds.ApptCust,
    //                 component: ComponentMapIds.ApptCust,
    //             });
    //             break;
    //         case '/appt':
    //             props.setViewMode(ViewMode.Appt);
    //             mainViewPanes.unshift({
    //                 viewId: ComponentMapIds.ApptCust,
    //                 component: ComponentMapIds.ApptCust,
    //             });
    //             props.pushToMainPanes({
    //                 viewId: ComponentMapIds.ApptCust,
    //                 component: ComponentMapIds.ApptCust,
    //             });
    //             break;
    //         case '/cust':
    //             props.setViewMode(ViewMode.CustAcct);
    //             mainViewPanes.unshift({
    //                 viewId: ComponentMapIds.Login,
    //                 component: ComponentMapIds.Login,
    //             });
    //             props.pushToMainPanes({
    //                 viewId: ComponentMapIds.Login,
    //                 component: ComponentMapIds.Login,
    //             });
    //             break;
    //         case '/RO':
    //             props.setViewMode(ViewMode.Repair);
    //             mainViewPanes.unshift({
    //                 viewId: ComponentMapIds.Login,
    //                 component: ComponentMapIds.Login,
    //             });
    //             props.pushToMainPanes({
    //                 viewId: ComponentMapIds.Login,
    //                 component: ComponentMapIds.Login,
    //             });
    //             break;
    //         default:
    //             props.history.push('/');
    //             break;
    //     }
    // }

    const clearVehicleStates = useCallback(() => {
        // Clear selected vehicle information
        props.selectVehicle('');
        props.clearAdditionalServices();
        props.clearMaintContractData();
        props.clearCheckedWebOps();
        props.clearNewVehicle();
        const blankVehicle = {
            vin: '',
            makeCode: '',
            make: '',
            model: '',
            series: '',
            vehYr: '',
            vehColor: '',
            mileage: 0,
            imagePath: '',
        };
        props.onUpdateApptVehicle(blankVehicle);
    }, [props?.clearAdditionalServices, props?.clearNewVehicle, props?.onUpdateApptVehicle, props?.selectVehicle,
        props?.clearCheckedWebOps, props.clearMaintContractData]);

    const clearCustomerStates = useCallback(() => {
        // If logging out or going back to customer search, clear customer data and customer vehicles
        const blankCust: Customer = {
            nameId: '', firstName: '', lastName: '', emailAddress: '',
            phoneNumber: '', login: false, prefContact: '', textOptIn: '',
            stateAddress: '', streetAddress: '', zipCode: '', emailOptIn: '',
            city: '', phoneType: '', addVehNameId: '', gmRedeemAmt: '',
            encryptFirst: '', encryptLast: '', encryptEmail: '', encryptPhone: '',
            ascCustId: '',
        };
        props.onCustUpdate(blankCust);
        props.clearApptCust();
        props.clearVehicles();
        props.waitForLogOff();
        props.logCustOff();
    }, [props?.clearVehicles, props?.clearApptCust, props?.onCustUpdate, props?.waitForLogOff, props?.logCustOff]);

    // This is the screen the user is on.
    const currentViewPanes = mainViewPanes[mainViewPanes.length - 1];
    // This is the ViewPane we will switch to with the Back Button.
    const newViewPanes = mainViewPanes[mainViewPanes.length - 2];

    const nextViewPanes = mainViewPanes[mainViewPanes.length - 3];

    const popPane = useCallback(() => {
        if (mainViewPanes.length === 1) {
            props.setViewMode(ViewMode.LandingPage);
            if (history) {
                history.goBack();
            }
            // props.history.push('/');
        } else {
            if (newViewPanes.viewId === ComponentMapIds.LandingPage) {
                if (history) {
                    history.goBack();
                }
                props.setViewMode(ViewMode.LandingPage);
            }
            props.popFromMainPane(currentViewPanes.viewId);
        }
    }, [currentViewPanes?.viewId, mainViewPanes?.length, props?.popFromMainPane, props?.setViewMode, newViewPanes, history]);

    const handleNewPane = useCallback(() => {
        if (newViewPanes) {
            if (newViewPanes.viewId === ComponentMapIds.CustSearch ||
            (newViewPanes.viewId === ComponentMapIds.Login && currentViewPanes.viewId !== ComponentMapIds.VerifyIdentity &&
                nextViewPanes.viewId !== ComponentMapIds.Summary) ||
            newViewPanes.viewId === ComponentMapIds.VehSel ||
            (currentViewPanes.viewId === ComponentMapIds.AddVehicle && newViewPanes.viewId === ComponentMapIds.OEMCustSearch) ||
            (currentViewPanes.viewId === ComponentMapIds.VehSel && newViewPanes.viewId === ComponentMapIds.OEMCustSearch)) {
                clearVehicleStates();
                props.clearCheckedAdditionalServices();
                props.clearCheckedWebOps();
                props.updateApptOps([]);
                // Clear customer states if we are logging out.
                if (newViewPanes.viewId !== ComponentMapIds.VehSel) {
                    clearCustomerStates();
                }
            }
            // If going back to the customer account screen, clear any appointment and operations data
            if (newViewPanes.viewId === ComponentMapIds.UserAccountMenu || newViewPanes.viewId === ComponentMapIds.VehLayout) {
                props.clearCheckedAdditionalServices();
                props.clearCheckedWebOps();
                const date: UpdateApptDateInp = {
                    selDate: '',
                    selTime: '',
                    selTrans: '',
                    selAdv: '',
                    selAdvName: '',
                    selAdvImage: '',
                    selTransFlag: '',
                    selApptNum: '',
                };
                props.updateApptDate(date);
                props.updateApptOps([]);
                props.setViewMode(ViewMode.CustAcct);
                props.clearMaintContractData();
            }

            if (newViewPanes.viewId === ComponentMapIds.VehSel && props.multipleCustomers) {
                // Need to keep inputs from search
                if (!props.apptCust?.custPhoneNumber?.includes('*') ||
                !props.apptCust?.custEmailAddress?.includes('*')) {
                    const apptCust: UpdateApptCustInp = {
                        nameId: '',
                        firstName: '',
                        lastName: '',
                        emailAddress: props.apptCust.custEmailAddress && !props.apptCust.custEmailAddress.includes('*') ?
                            props.apptCust.custEmailAddress: '',
                        phoneNumber: props.apptCust.custPhoneNumber && !props.apptCust.custPhoneNumber.includes('*') ?
                            props.apptCust.custPhoneNumber: '',
                        prefContact: '',
                    };
                    props.updateApptCust(apptCust);
                } else {
                    props.clearApptCust();
                }
            }

            if (newViewPanes.viewId === ComponentMapIds.AddVehicle) {
                props.updateApptOps([]);
                props.clearCheckedWebOps();
                props.clearCheckedAdditionalServices();
            }

            if (newViewPanes.viewId === ComponentMapIds.QuickTime || newViewPanes.viewId === ComponentMapIds.CalendarSelect) {
                const date: UpdateApptDateInp = {
                    selDate: '',
                    selTime: '',
                    selTrans: '',
                    selAdv: '',
                    selAdvName: '',
                    selAdvImage: '',
                    selTransFlag: '',
                    selApptNum: '',
                };
                props.updateApptDate(date);
            }
        }
    }, [clearCustomerStates, clearVehicleStates, props.multipleCustomers, currentViewPanes?.viewId, newViewPanes, nextViewPanes,
        props?.setViewMode, props.clearCheckedWebOps, props.clearCheckedAdditionalServices, props.updateApptDate,
        props.updateApptOps, props.clearApptCust, props.apptCust, props.updateApptCust, props.clearMaintContractData]);

    const backHandler = useCallback(() => {
        if (newViewPanes && (newViewPanes.viewId === ComponentMapIds.CustSearch ||
        newViewPanes.viewId === ComponentMapIds.Login || newViewPanes.viewId === ComponentMapIds.UserAccountMenu) &&
        props.custVehicles && props.custNameId && props.vehicles.length > props.custVehicles?.length) {
            // If backing out of the appointment with a new vehicle, warn the user that they will lose their vehicle
            setBackWarning(true);

            return;
        } else {
            if (newViewPanes) {
                props.addLogEntry('Menu Back Btn', newViewPanes.viewId, '');
                if (newViewPanes.viewId === ComponentMapIds.AddVehicle) {
                    props.clearAddVinError();
                }
            } else {
                props.addLogEntry('Menu Back Btn', '', '');
            }
            props.setVerifyingIdentity(false);
            if (currentViewPanes.viewId === ComponentMapIds.VerifyIdentity) {
                props.setSendSecurityCode(false);
            }
            popPane();
        }
        if (newViewPanes && newViewPanes.viewId === ComponentMapIds.VehSel && !props.login) {
            props.clearGMInfo();
        }

        handleNewPane();

        const ascMenuInteractionInp : ascMenuInteractionInput = {
            pageType: 'service',
            elementText: strings.Back,
            elementSubtype: 'nav_button',
            elementType: 'service',
            eventAction: 'click',
        };
        ascMenuInteraction(ascMenuInteractionInp);
    }, [newViewPanes, currentViewPanes?.viewId, props?.custVehicles, props?.custNameId, props?.vehicles?.length, props.login,
        handleNewPane, popPane, props.addLogEntry, props.setVerifyingIdentity, props.setSendSecurityCode, props.clearGMInfo,
        props.clearAddVinError]);

    // if color theme is colorSensitive change to use the Alternate Css to remove the background image.
    let backdropDefault = false;
    let bgImage = 'url(' + props.specData?.BGUrl + ')';

    // If we dont have a background image then check if we have an OEM background
    // Otherwise set it to transparent so the default image will appear.
    let oemBGPath = '';
    if (props.theme === 'colorSensitive' || props.theme === 'lexusMonogram' || props.theme === 'mercedesBenz' ||
        props.theme === 'cjdr') {
        bgImage = '';
    } else if (!props.specData?.BGUrl || props.specData?.BGUrl === ' ') {
        if (props.specData?.oemTheme) {
            oemBGPath = getBackgroundPath(props.specData.oemTheme);
            if (oemBGPath) {
                bgImage = oemBGPath;
            }
        }
        if (!props.specData?.oemTheme || !oemBGPath) {
            backdropDefault = true;
            bgImage = 'transparent';
        }
        // if we are in Online Service Docs, then check if background url override exists
        if (props.serviceDocsSpecs && (props.serviceDocsFlag === 'Y' || props.viewServiceHistFlag === 'Y')) {
            oemBGPath = getBackgroundPath(props.serviceDocsSpecs.theme);
            if (oemBGPath) {
                bgImage = oemBGPath;
            }
            if (props.serviceDocsSpecs.backgroundURL) {
                bgImage = 'url(' + props.serviceDocsSpecs.backgroundURL + ')';
            }
        }
    }

    const cancelHandler = useCallback(() => {
        setBackWarning(false);
    }, []);

    const continueHandler = useCallback(() => {
        props.getVehicles();
        setBackWarning(false);
        popPane();
        handleNewPane();
    }, [handleNewPane, popPane, props.getVehicles]);

    let error: JSX.Element | null = null;
    if (backWarning) {
        error = (<ErrorMessage
            headerMsg={strings.LosingVehicle}
            errorMsg={strings.LoseAddedVehicleWarning}
            primaryBtnMessage={strings.Continue}
            secondaryBtnMessage={strings.Cancel}
            primaryHandler={continueHandler}
            secondaryHandler={cancelHandler}
            closeHandler={cancelHandler}
        />);
    }

    const backdropClasses = classNames(
        [css.backdrop],
        {
            [css.backdropDefault]: backdropDefault,
        },
    );

    let bodyCSS = css.body;
    if (props.viewMode === ViewMode.LandingPage) {
        bodyCSS = css.bodyLand;
    }

    // awaiting correct URLs
    /* const privacyTerms = classNames(
        [css.privacyTerms],
        {
            [css.privacyTermsAlt]: props.viewMode === 2 || props.viewMode === 3,
        },
    );

    const privacyTermsHidden = props.mainPaneViewOrder[props.mainPaneViewOrder?.length-1]?.viewId === 'ServiceDocs' ?
        true : false; */


    return (
        <div className={backdropClasses} style={{ backgroundImage: bgImage }} >
            {
                (isPreview === true && (currentViewPanes.viewId !== ComponentMapIds.ServiceDocs &&
                    currentViewPanes.viewId !== ComponentMapIds.DocumentViewer)) ?
                    <PreviewOverlay locale={props.locale}/> :
                    null
            }
            {
                props.viewMode === ViewMode.CustAcct ?
                    <MenuCustAppt back={backHandler} /> :
                    null
            }
            {
                props.viewMode === ViewMode.Repair ?
                    <MenuCustAppt back={backHandler} /> :
                    null
            }
            {
                props.viewMode === ViewMode.Appt ?
                    <Menu
                        back={backHandler} /> :
                    null
            }
            {
                props.viewMode === ViewMode.EditAppt ?
                    <Menu
                        back={backHandler} /> :
                    null
            }
            {/* Add menu for service docs here */}
            {
                props.viewMode === ViewMode.ServiceDocs ?
                    <MenuServiceDocs /> :
                    null
            }
            { props.viewMode === ViewMode.LandingPage ?
                <div className={langLandBtnCss} onClick={(e: any) => changeLanguage(e, langLit)}>
                    {langLit}
                </div> : null }
            <div className={bodyCSS}>
                {error}
                <ViewPane
                    renderer={RenderComponent}
                    views={mainViewPanes}
                    className={css.viewPane}
                />
            </div>
            {/* Privacy and Terms links added to the bottom of the page across from the Accessibility icon*/}
            <div>
                {/* { (props.locale === 'en-US' && !privacyTermsHidden) ? <div>
                    <p className={privacyTerms}>
                        <a href='' target='_blank' rel='noreferrer'>Privacy </a>
                    |<a href='' target='_blank' rel='noreferrer'> Terms</a>
                    </p>
                </div> : null } */}
                { props.viewMode === ViewMode.LandingPage ?
                    null :
                    <div onClick={(e:any) => changeLanguage(e, langLit)}>
                        <p className={langBtnCss} >
                            {langLit}
                        </p>
                    </div>}
                <div className={css.accessibility}>
                    <Accessibility />
                </div>
            </div>
        </div>
    );
};

export default Main;